import type {MostSearchedFeatureDefinition} from '../types/MostSearchedFeatureDefinition';

// Source of the data: https://docs.google.com/spreadsheets/d/1lsfIpOGsMJcdKcvInW0ikLicE0ZssUTHSQ0qEogBRQw/edit?gid=656250194
const MOST_SEARCHED_FEATURE_DEFINITIONS: MostSearchedFeatureDefinition[] = [
  {rank: 2, label: 'Heated front seats', featureCode: 'FEATURE_FRONT_SEATS_HEATED'},
  {rank: 4, label: 'Navigation system', featureCode: 'FEATURE_NAVIGATION_SYSTEM'},
  {rank: 5, label: 'Panoramic roof', featureCode: 'FEATURE_PANORAMIC_ROOF'},
  {rank: 6, label: 'Sunroof', featureCode: 'FEATURE_SUNROOF'},
  {rank: 7, label: 'Auxiliary heating', featureCode: 'FEATURE_AUXILIARYHEATING'},
  {rank: 9, label: 'Sport package', featureCode: 'FEATURE_SPORT_PACKAGE'},
  {rank: 11, label: 'Head-up display', featureCode: 'FEATURE_HEAD_UP_DISPLAY'},
  {rank: 13, label: 'Digital cockpit', featureCode: 'FEATURE_DIGITAL_COCKPIT'},
  {rank: 14, label: 'Apple CarPlay integration', featureCode: 'FEATURE_APPLE_CARPLAY'},
  {rank: 15, label: 'Bluetooth connectivity', featureCode: 'FEATURE_BLUETOOTH'},
  {rank: 16, label: 'Electric tailgate', featureCode: 'FEATURE_ELECTRIC_TAILGATE'},
  {
    rank: 17,
    label: 'Electric seat adjustment',
    featureCode: 'FEATURE_FRONT_SEATS_ELECTRIC_ADJUSTABLE',
  },
  {rank: 19, label: 'Sport seats', featureCode: 'FEATURE_FRONT_SEATS_SPORT_SEATS'},
  {rank: 20, label: 'Ambient lighting', featureCode: 'FEATURE_AMBIENT_LIGHTING'},
  {
    rank: 21,
    label: 'Multifunctional steering wheel',
    featureCode: 'FEATURE_MULTIFUNCTIONAL_STEERING_WHEEL',
  },
  {rank: 22, label: 'Heated steering wheel', featureCode: 'FEATURE_HEATED_STEERING_WHEEL'},
  {rank: 23, label: 'Premium sound system', featureCode: 'FEATURE_AUDIO_EXTRA'},
  {
    rank: 24,
    label: 'Electric windows',
    featureCode: 'FEATURE_ELECTRIC_WINDOWS_FRONT_ELECTRIC_WINDOWS',
  },
  {
    rank: 25,
    label: 'Lane change assist / blind spot',
    featureCode: 'FEATURE_LANE_CHANGE_ASSIST',
  },
  {rank: 26, label: 'Hands-free phone', featureCode: 'FEATURE_HANDSFREE'},
  {rank: 27, label: 'Rain sensor / rain-sensing wipers', featureCode: 'FEATURE_RAIN_SENSOR'},
  {
    rank: 28,
    label: 'Traffic sign recognition',
    featureCode: 'FEATURE_TRAFFIC_SIGN_RECOGNITION',
  },
  {
    rank: 29,
    label: 'Lane departure warning / keep assist',
    featureCode: 'FEATURE_LANE_ASSIST_BASIC',
  },
  {
    rank: 30,
    label: 'Electric side mirrors',
    featureCode: 'FEATURE_SIDE_MIRRORS_WITH_ELECTRIC_ADJUSTMENT',
  },
  {
    rank: 31,
    label: 'Ventilated / cooled front seats',
    featureCode: 'FEATURE_FRONT_SEATS_VENTILATED',
  },
  {rank: 32, label: 'Android Auto support', featureCode: 'FEATURE_ANDROID_AUTO'},
  {rank: 33, label: 'Keyless entry system', featureCode: 'FEATURE_KEYLESS_ENTRY'},
  {rank: 34, label: 'Air suspension', featureCode: 'FEATURE_AIR_SUSPENSION'},
  {rank: 35, label: 'Sport suspension', featureCode: 'FEATURE_SPORT_SUSPENSION_SYSTEM'},
  {rank: 36, label: 'Central locking', featureCode: 'FEATURE_CENTRAL_LOCKING'},
  {rank: 37, label: 'ABS (anti-lock braking)', featureCode: 'FEATURE_ABS'},
  {rank: 38, label: 'Alloy wheels', featureCode: 'FEATURE_ALLOY_WHEELS'},
  {rank: 39, label: 'Power-assisted steering', featureCode: 'FEATURE_POWER_ASSISTED_STEERING'},
  {rank: 40, label: 'Heated windshield', featureCode: 'FEATURE_HEATED_WINDSHIELD'},
  {rank: 41, label: 'Hill start assist', featureCode: 'FEATURE_HILL_START_ASSIST'},
  {rank: 42, label: 'On-board computer', featureCode: 'FEATURE_ON_BOARD_COMPUTER'},
  {rank: 43, label: 'ISOFIX child seat anchor', featureCode: 'FEATURE_REAR_SEATS_ISOFIX'},
  {
    rank: 44,
    label: 'Front collision warning',
    featureCode: 'FEATURE_FRONT_COLLISION_WARNING_SYSTEM',
  },
  {
    rank: 45,
    label: 'Automatic emergency braking',
    featureCode: 'FEATURE_EMERGENCY_BRAKING_ASSIST_EBA_BAS',
  },
  {
    rank: 46,
    label: 'Automatic high beams / high beam assist',
    featureCode: 'FEATURE_HIGH_BEAM_ASSIST',
  },
  {
    rank: 47,
    label: 'Massage seats',
    featureCode: 'FEATURE_FRONT_SEATS_WITH_MASSAGE_FUNCTION_DRIVER',
  },
  {rank: 48, label: 'Start-stop system', featureCode: 'FEATURE_START_STOP_SYSTEM'},
  {rank: 49, label: 'Armrest', featureCode: 'FEATURE_ARMREST'},
  {
    rank: 50,
    label: 'Rear heated seats',
    featureCode: 'FEATURE_REAR_SEATS_HEATED_REAR_SEATS',
  },
  {rank: 51, label: 'Roof rails', featureCode: 'FEATURE_ROOF_RAILS'},
  {
    rank: 52,
    label: 'Leather-wrapped steering wheel',
    featureCode: 'FEATURE_LEATHER_STEERING_WHEEL',
  },
  {rank: 53, label: 'Light sensor / automatic lights', featureCode: 'FEATURE_LIGHT_SENSOR'},
  {rank: 54, label: 'ESP / stability control', featureCode: 'FEATURE_ESP'},
  {rank: 55, label: 'Lumbar support', featureCode: 'FEATURE_LUMBAR_SUPPORT_DRIVER'},
  {
    rank: 56,
    label: 'Auto-dimming interior mirror',
    featureCode: 'FEATURE_SIDE_MIRRORS_AUTO_DIMMING_SIDE_MIRRORS',
  },
  {rank: 57, label: 'Fog lights', featureCode: 'FEATURE_FRONT_FOG_LIGHTS'},
  {
    rank: 58,
    label: 'Wireless charging pad',
    featureCode: 'FEATURE_INDUCTION_CHARGING_FOR_SMARTPHONES',
  },
  {
    rank: 59,
    label: 'Tire pressure monitoring',
    featureCode: 'FEATURE_TYRE_PRESSURE_MONITORING',
  },
  {
    rank: 61,
    label: 'Winter wheel set / winter package',
    featureCode: 'FEATURE_WINTER_WHEEL_SET',
  },
  {rank: 62, label: 'USB port', featureCode: 'FEATURE_USB'},
  {rank: 63, label: 'Diesel particulate filter', featureCode: 'FEATURE_DIESEL_PARTICULATE_FILTER'},
  {rank: 64, label: 'Paddle shifters', featureCode: 'FEATURE_PADDLE_SHIFTERS'},
  {
    rank: 65,
    label: 'Glare-free / matrix high beam',
    featureCode: 'FEATURE_GLARE_FREE_HIGH_BEAM_HEADLIGHTS',
  },
  {rank: 66, label: 'Touchscreen infotainment', featureCode: 'FEATURE_TOUCH_SCREEN'},
  {rank: 67, label: 'Speed limiter', featureCode: 'FEATURE_SPEED_LIMITER'},
  {rank: 68, label: 'Alarm system', featureCode: 'FEATURE_ALARM'},
  {rank: 69, label: 'Traction control (TC/ASR)', featureCode: 'FEATURE_TRACTION_CONTROL_TC_ASR'},
  {
    rank: 70,
    label: 'Fatigue / drowsiness warning',
    featureCode: 'FEATURE_FATIGUE_WARNING_SYSTEM',
  },
  {rank: 71, label: 'Winter tyres', featureCode: 'FEATURE_WINTER_TYRES'},
  {rank: 72, label: 'CD player', featureCode: 'FEATURE_CD_PLAYER'},
  {rank: 73, label: 'Voice control', featureCode: 'FEATURE_VOICE_CONTROL'},
  {rank: 74, label: 'Disabled accessible', featureCode: 'FEATURE_DISABLED_ACCESSIBLE'},
  {rank: 75, label: 'Taxi', featureCode: 'FEATURE_TAXI'},
  {rank: 76, label: 'Electronic immobilizer', featureCode: 'FEATURE_IMMOBILIZER'},
  {rank: 77, label: 'Night vision assist', featureCode: 'FEATURE_NIGHT_VISSION_ASSIST'},
  {rank: 78, label: 'Emergency call (eCall)', featureCode: 'FEATURE_EMERGENCY_CALL'},
  {rank: 79, label: 'Wi-Fi hotspot', featureCode: 'FEATURE_WLAN_WIFI_HOTSPOT'},
  {
    rank: 80,
    label: 'Integrated music streaming',
    featureCode: 'FEATURE_INTEGRATED_MUSIC_STREAMING',
  },
  {rank: 81, label: 'TV', featureCode: 'FEATURE_TV'},
  {rank: 82, label: 'Cargo barrier', featureCode: 'FEATURE_CARGO_BARRIER'},
  {rank: 83, label: 'Headlamp washers', featureCode: 'FEATURE_HEADLAMP_WASHERS'},
  {
    rank: 84,
    label: 'Electric rear seat adjustment',
    featureCode: 'FEATURE_REAR_SEATS_ELECTRIC_ADJUSTABLE_REAR_SEATS',
  },
  {rank: 85, label: 'Trailer coupling / tow hitch', featureCode: 'FEATURE_TRAILERCOUPLING'},
  {rank: 86, label: 'Ski bag', featureCode: 'FEATURE_SKI_BAG'},
  {rank: 87, label: 'LED headlights', featureCode: 'FEATURE_HEADLIGHTSTYPE_LED'},
  {rank: 88, label: 'Adaptive cruise control', featureCode: 'FEATURE_CRUISECONTROL_ADAPTIVE'},
  {rank: 89, label: 'Cruise control', featureCode: 'FEATURE_CRUISECONTROL_BASIC'},
  {rank: 90, label: 'Xenon headlights', featureCode: 'FEATURE_HEADLIGHTSTYPE_XENON'},
  {
    rank: 91,
    label: 'Parking sensors / parking assist',
    featureCode: 'FEATURE_PARKINGSENSORS',
  },
  {rank: 92, label: 'Cornering lights', featureCode: 'FEATURE_CORNERING_LIGHTS'},
  {rank: 93, label: 'MP3 interface', featureCode: 'FEATURE_MP3_INTERFACE'},
  {rank: 94, label: 'Daytime running lights', featureCode: 'FEATURE_DAYTIME_RUNNING_LIGHTS'},
  {rank: 95, label: 'Radio / tuner', featureCode: 'FEATURE_RADIO'},
];

export function getMostSearchedFeatureDefinitions(): MostSearchedFeatureDefinition[] {
  return MOST_SEARCHED_FEATURE_DEFINITIONS;
}
